import {EnergyBox} from "../models/elements/EnergyBox";
import {IEnergyBoxSticker} from "../models/utils/IEnergyBoxSticker";

/**
 * Service managing the decoding of all sticker formats.
 * @author Alizée Grand
 * @version 1.0
 * @creation 28/02/2022
 * @last_update 28/02/2022
 **/
class StickerService {

    /**
     * Retrieves the content of a label and returns the serial number and the lora id.
     * @param {string} stickerContent
     * @return {IEnergyBoxSticker | undefined}
     */
    public decodeSticker(stickerContent: string): IEnergyBoxSticker | undefined {
        let sticker: IEnergyBoxSticker | undefined = undefined;
        if(EnergyBox.isLoraIdRightFormat(stickerContent)) {
            sticker = {loraId: stickerContent};
        }
        else if (EnergyBox.isSerialNumberRightFormat(stickerContent)) {
            sticker = {serialNumber: stickerContent};
        }
        else if(this.stickerInFormat1(stickerContent)) {
            sticker = this.stickerInFormat1(stickerContent);
        }
        else if (this.stickerInFormat2(stickerContent)) {
            sticker = this.stickerInFormat2(stickerContent);
        }
        else if (this.stickerInFormat3(stickerContent)) {
            sticker = this.stickerInFormat3(stickerContent);
        }
        return sticker;
    }

    /**
     * Format 1 : serialNumber/loraId (with : or not)
     * @param {string} stickerContent
     * @return {IEnergyBoxSticker | undefined}
     * @private
     */
    private stickerInFormat1(stickerContent: string): IEnergyBoxSticker | undefined {
        let sticker: IEnergyBoxSticker | undefined = undefined;
        let stickerParts = stickerContent.split("/");
        if(stickerParts.length === 2 && EnergyBox.isSerialNumberRightFormat(stickerParts[0]) && EnergyBox.isLoraIdRightFormat(stickerParts[1])) {
            sticker = {
                serialNumber: stickerParts[0],
                loraId: stickerParts[1]
            };
        }
        return sticker;
    }

    /**
     * Format 2 : www.fonroche-lighting.com?tracker=loraIdSerialNumber
     * @param {string} stickerContent
     * @return {IEnergyBoxSticker | undefined}
     * @private
     */
    private stickerInFormat2(stickerContent: string): IEnergyBoxSticker | undefined {
        let sticker: IEnergyBoxSticker | undefined = undefined;
        let stickerParts = stickerContent.split("=");
        if(stickerParts.length === 2 && stickerParts[0] === "www.fonroche-lighting.com?tracker" && stickerParts[1].length === 30) {
            let loraId = stickerParts[1].slice(0, 16);
            let serialNumber = stickerParts[1].slice(16);
            if(EnergyBox.isLoraIdRightFormat(loraId) && EnergyBox.isSerialNumberRightFormat(serialNumber)) {
                sticker = {
                    serialNumber: serialNumber,
                    loraId: loraId
                }
            }
        }
        return sticker;
    }

    /**
     * Format 3 : loraId(with : or not)/serialNumber
     * @param {string} stickerContent
     * @return {IEnergyBoxSticker | undefined}
     * @private
     */
    private stickerInFormat3(stickerContent: string): IEnergyBoxSticker | undefined {
        let sticker: IEnergyBoxSticker | undefined = undefined;
        let stickerParts = stickerContent.split("/");
        if(stickerParts.length === 2 && EnergyBox.isSerialNumberRightFormat(stickerParts[1]) && EnergyBox.isLoraIdRightFormat(stickerParts[0])) {
            sticker = {
                serialNumber: stickerParts[1],
                loraId: stickerParts[0]
            };
        }
        return sticker;
    }
}

export default new StickerService();
